/* REACT PACKAGE IMPORTS */
import {  Button } from "react-bootstrap";

/* ENTRA IMPORTS */
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";

/* MUI PACKAGE IMPORTS */
import MicrosoftIcon from '@mui/icons-material/Microsoft';
import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';

/* INTERNAL IMPORTS */
import "../styles/Login.css";

export default function LoginEntra({ logo }) {
  const { instance } = useMsal();

  const handleRedirect = () => {
    instance
      .loginRedirect({
        ...loginRequest,
        prompt: "create",
      })
      .catch((error) => console.log(error));
  };

  const handleLogoutRedirect = () => {
    instance.logoutRedirect().catch((error) => console.log(error));
  };

  return (
    <main className="Login ">
      <div
        className="Login-container box position-absolute top-50 start-50 translate-middle py-8 px-5 flex flex-col gap-3 justify-center items-center">
        <div className="d-flex flex-column justify-center items-center">
          <img src={logo} alt="Logo" className="h-40"/>
        </div>
        <Button
          className="flex gap-x-2 p-3 px-5 w-fit text-base justify-center"
          variant="primary"
          onClick={handleRedirect}
        >
          <MicrosoftIcon fontSize={"medium"} />
          <span>Sign In With Microsoft Entra</span>
        </Button>
        <Button
          className="signInButton flex gap-2 p-3 px-5 text-base justify-center container w-fit"
          variant="outline-primary"
          onClick={handleLogoutRedirect}
        >
          <ExitToAppOutlinedIcon fontSize={"medium"}/>
          <span>Sign Out Of Microsoft Entra</span>
        </Button>
        <p className={"text-secondary text-sm flex-start p-0 mb-4"}>Issues signing in? Try signing out first with the button above</p>
        <a href={"/"} target={"_blank"} className={"underline inter-light text-sm"}>Open application in another tab</a>
      </div>
    </main>
  );
}
